const data: string = JSON.stringify([
  { MeasureValue: '1', Time: '1607200000' },
  { MeasureValue: '3', Time: '1607200002' },
  { MeasureValue: '2', Time: '1607200005' },
  { MeasureValue: '5', Time: '1607200009' },
  { MeasureValue: '4', Time: '1607200012' },
]);

export default data;
